// src/Features/HotelList/Components/HotelCard/HotelCard.jsx
import React from "react";
import "./HotelCard.css";
import { Row, Col, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import Cookies from "js-cookie"

export default function HotelCard({ hotel, loading = false, onClick }) {



  if (loading) {
    return (
      <div className="hotellist-card-contianer">
        <div className="hotellist-card-content placeholder-glow">
          <Row className="g-3 align-items-center">
            <Col md="auto">
              <div className="hotellist-img-container bg-light rounded-4 placeholder" />
            </Col>
            <Col>
              <div className="mb-2">
                <div className="placeholder col-7 mb-2" style={{ height: 16 }} />
                <div className="placeholder col-5 mb-2" style={{ height: 12 }} />
              </div>
              <div className="d-flex gap-2 my-2 flex-wrap">
                <span className="badge bg-light text-light border placeholder col-2" style={{ height: 24 }} />
                <span className="badge bg-light text-light border placeholder col-3" style={{ height: 24 }} />
                <span className="badge bg-light text-light border placeholder col-2" style={{ height: 24 }} />
              </div>
              <div className="placeholder col-10 mb-1" style={{ height: 12 }} />
              <div className="placeholder col-9" style={{ height: 12 }} />
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  const features = Array.isArray(hotel.features) ? hotel.features : [];
  const shown = features.slice(0, 3);
  const remaining = Math.max(0, features.length - 3);
  const tooltipText = features.join(", ");

  const Lang = Cookies.get("preferred_language") || "en";

  return (
    <div className="hotellist-card-contianer" onClick={onClick}>
      <div className="hotellist-card-content">
        <Row className="g-3 align-items-center">
          <Col md="auto">
            <div className="hotellist-img-container">
              <img
                className="hotel-image"
                src={hotel.image}
                alt={hotel.name}
                style={{ objectFit: "cover", borderRadius: 16 }}
              />
            </div>
          </Col>

          <Col>
            <h6 className="mb-1">{hotel.name}</h6>

            <div className="text-muted small">
              {hotel.area ? (
                <>
                  {hotel.area}, <b>{hotel.city}</b>
                </>
              ) : (
                <b>{hotel.city}</b>
              )}
            </div>

            <div className="d-flex gap-2 my-2 flex-wrap">
              {shown.map((f, idx) => (
                <Badge bg="light" text="dark" key={`${f}-${idx}`} className="border">
                  {f}
                </Badge>
              ))}

              {remaining > 0 && (
                
                  <Badge bg="light" text="dark" className="border" style={{ cursor: "help" }}>
                    +{remaining}
                  </Badge>
                
              )}
            </div>

            {hotel.promo && (
              <div className="fw-semibold small hotellist-promo">Description</div>
            )}

            {hotel.dis && <div className="hotellist-desc-clamp">{hotel.dis}</div>}
          </Col>

          <Col md="2" className="hotellist-right-section">
            <div className="h5 mb-0 hotellist-price-container">
              <span className="hotellist-price-text">${hotel.price}</span>
              {hotel.oldPrice && (
                <div className="text-muted text-decoration-line-through small">
                  <span className="hotellist-old-price-text">${hotel.oldPrice}</span>
                </div>
              )}
            </div>
            <small>Base Price</small>

            <div className="mt-2 hotellist-rating-container">
              <Badge className={`${Lang === "ar" ? "ms-1" : "me-1"} hotellist-rating-badge`}>
                {Number(hotel.rating).toFixed(1)}
              </Badge>
              <span className="small fw-semibold">Rate</span>
            </div>

            {hotel.refundable && (
              <div className="mt-2">
                <span className="small refundable-text">Fully Refundable</span>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
}
